import React, { useContext, useEffect, useState } from "react";

import { Layout, Typography} from "antd";
import { TransactionOutlined } from '@ant-design/icons';

import MenuSide from "../components/menuSide";
import ListTransaction from "../components/listTransaction"
import { MenuOutlined  } from '@ant-design/icons';


import { AppContext } from '../App';

const { Header, Content } = Layout;
const { Title } = Typography;

const Transaction = () => {

  const { user } = useContext(AppContext);
  if(user){ 
    if(user.role !== 'admin'){      
      window.location.href = "/home"; 
    }
  }

  const [width, setWidth] = useState(window.innerWidth);
  const [menuDisplay, setMenuDisplay] = useState(false);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

    const handleMenu = (value) => {
      setMenuDisplay(value)
    }


    return (
      width < 1000 ?
      <Layout className="fullHeight">
          {menuDisplay ? <MenuSide/> : <MenuOutlined onClick={()=>handleMenu(true)} style={{margin:20}}/>}
          <Content className="contentSection" onClick={()=>handleMenu(false)}>
            <Title level={3} ><TransactionOutlined /> รายการชำระเงิน</Title>
            <ListTransaction />
        </Content>
    </Layout>
      :
      <Layout className="fullHeight">
          <MenuSide />
          <Content className="contentSection">
            <Title level={3} ><TransactionOutlined /> รายการชำระเงิน</Title>
            <ListTransaction />
          </Content>
      </Layout>
    )
  };
  
  export default Transaction;
  